<template>
  <div class="attention_entity">
      <div class="attention_content_title">关注的机构</div>
      <div class="attention_tip" v-if="show_attention_com && show_attention_com.length == 0">
          <p>选择您关注的机构，让动脉橙更懂你~</p>
      </div>
      <div class="entity_checked" v-if="show_attention_com && show_attention_com.length > 0">
          <div class="checked">
              <div class="checked1">
                  已关注
              </div>
              <div class="checked3">
                  <a v-if="!all_show && attention_com.length > 3" @click="showMore">更多<i class="iconfont">&#xe648;</i></a>
                  <a v-if="all_show && attention_com.length > 3" @click="showMore">收起<i class="iconfont">&#xe63b;</i></a>
              </div>
          </div>
          <div class="checked2">
            <ul class="checked_ul clear">
              <li v-if="tag_loading">
                <div class="tag_loading">
                  <Spin fix>
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  </Spin>
                </div>
              </li>
              <li v-for="(item,index) in show_attention_com">
                <div class="logo_img" @click="goEntityDetail(item.uid)">
                  <img :src="item.logo_path | logo_show" />
                </div>
                <div class="entity_info">
                  <p class="p1 clear"><span class="span_name" @click="goEntityDetail(item.uid)">{{item.short_name}}</span><span class="span_tag" v-if="item.round_id">{{item.round_id | deal('round')}}</span></p>
                  <p class="p2" v-if="item.description">{{item.description}}</p>
                  <p class="p2" v-else>暂无描述</p>
                </div>
                <div class="entity_chk">
                  <Dropdown class="cancel" placement="bottom-start" @on-click="deleteConfirm(item,'top')">
                    <i class="iconfont">&#xe64b;</i>
                    <DropdownMenu slot="list">
                      <DropdownItem>取消关注</DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </li>
            </ul>
          </div>
      </div>
      <div class="entity_search">
          <Icon type="ios-search" />
          <Input v-model="entity_key" placeholder="输入关键词" @on-enter="searchEntity"/>
      </div>
      <div class="entity_options" v-if="len > 0">
          <p v-if="!is_tj" class="tip">共查询到<span>{{len}}</span>个关于“ <span>{{entity_keys}}</span> ”的机构</p>
          <div v-else class="recommend-div">
            <p>热门推荐</p>
            <p @click="searchEntity('create')"><i>&#xe65d;</i>换一批</p>
          </div>
          <ul class="entity_ul clear">
              <li v-for="(item,index) in search_list" :key="index">
                  <div class="logo_img" @click="goEntityDetail(item.uid)">
                      <img :src="item.logo_path | logo_show" />
                  </div>
                  <div class="entity_info">
                      <p class="p1 clear"><span class="span_name" @click="goEntityDetail(item.uid)">{{item.short_name}}</span><span class="span_tag" v-if="item.round_id">{{item.round_id | deal('round')}}</span></p>
                      <p class="p2" v-if="item.description">{{item.description}}</p>
                      <p class="p2" v-else>暂无描述</p>
                  </div>
                  <div class="entity_chk">
                      <span class="spa1" v-if="!item.is_active" @click="addSubscribe(item)"><i class="iconfont">&#xe64a;</i>关注</span>
                      <Dropdown v-else class="cancel" placement="bottom-start" @on-click="deleteConfirm(item,'bottom')">
                          <span class="spa2"><i class="iconfont">&#xe64b;</i>已关注</span>
                          <DropdownMenu slot="list">
                              <DropdownItem>取消关注</DropdownItem>
                          </DropdownMenu>
                      </Dropdown>
                  </div>
              </li>
          </ul>
          <p v-if="!is_tj && len > 10" class="more">想要了解更多信息数据，<a @click="handleMoreEntity('OrgList', entity_keys)">点击查看</a></p>
      </div>
      <p v-if="len == 0 && !first_search" class="tip_no">暂无相关信息</p>
      <Spin
        fix
        class="a-fix"
        v-if="loading1 || loading2"
      >
        <Icon
          type="ios-loading"
          size=18
          class="demo-spin-icon-load"
        ></Icon>
        <div>Loading</div>
      </Spin>
  </div>
</template>

<script>
import { attention_mixins } from 'js/attention_mixins'
import { addSubscribe,deleteSubscribe,findEntity,recommend } from '../../../service'

export default {
  name: 'AttentionCompany',
  mixins: [attention_mixins],
  data() {
    return {
      entity_key: '',
      entity_keys: '',
      all_show: false,
      tag_loading: false,
      clear_loading: false,
      loading1: true,
      loading2: true,
      search_list: [],
      len: 0,
      attention_com: [],
      show_attention_com: [],
      first_search: true,
      is_tj: true,
      recommend_page: 0
    }
  },
  computed: {
    group_subscribe() {
      let g_subscribe = []
      this.attention.subscribe.map((b) => {
        if(b.sub_type == '1'){
          g_subscribe.push({
            create_time: b.create_time,
            id: b.id,
            sub_type: b.sub_type,
            sub_type_id: b.sub_type_id,
          })
        }
      })
      return g_subscribe
    },
    sel_com_id() {
      let sel_com_id = []
      this.group_subscribe.map((a) => {
        sel_com_id.push(a.sub_type_id)
      })
      return sel_com_id
    },
    sel_com() {
      let sel_com = []
      this.group_subscribe.map((a) => {
        sel_com.push({
          a_id: a.id,
          sub_type_id: a.sub_type_id
        })
      })
      return sel_com
    }
  },
  methods: {
    async addSubscribe (item) {
      this.$emit('showlimit', '1', async() => {
        if(!this.tag_loading){
          this.tag_loading = true
          const add_tag = {
            sub_type: '1',
            sub_type_id: item.id,
            user_key: this.user_key
          }
          let res = await addSubscribe(add_tag, (error) => {
            this.$Message.error('请求错误！')
          })
          if(res.status == 'success') {
            item.is_active = true
            item.a_id = res.res
            this.getSubscribeList()
          } else {
            console.log(res)
          }
        }else{
          this.$Message.loading("添加中，请勿重复操作！")
        }
      })
    },
    deleteConfirm(item, place) {
      const _that = this
      layer.confirm('确定不再关注？<br />取消关注，其他分组同步取消哦~', {
        title: false,
        offset: '100px',
        skin: 'layer-custom',
        btn: ['确定','取消'] //按钮
      }, function(){
        _that.clearAttention(item, place)
        layer.closeAll()
      }, function(){
        layer.closeAll()
      })
    },
    async clearAttention(item,place) {
      if(!this.clear_loading) {
        this.clear_loading = true

        let del_group = {
            op_type: 'cancel',
            subscribe_id: item.a_id,
            user_key: this.user_key
        }
        let res = await deleteSubscribe(del_group, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          const _that = this
          this.getSubscribeList(_that.$Message.success('取消成功！'))
          if(place == 'top'){
            if(this.search_list != []){
              let index = this.search_list.findIndex((obj) => {
                return obj.id == item.id
              })
              if(index > -1){
                this.search_list[index].is_active = false
                this.search_list[index].a_id = ''
              }
            }
          }else{
            item.is_active = false
            item.a_id = ''
          }
        } else {
          this.$Message.error(res.message)
        }
      }else{
        this.$Message.loading("删除中，请勿重复操作！")
      }
    },
    async searchEntity(from) {
      let res
      if(from == 'create') {
        _czc.push(['_trackEvent', '动脉橙快讯关注', '机构推荐换一批点击'])
        this.recommend_page = this.recommend_page + 1
        if(this.recommend_page > 10) {
          this.recommend_page = 1
        }
        res = await recommend({type: 1, user_key: this.$store.state.user_key, page: this.recommend_page}, (error) => {
          this.$Message.error('请求错误！')
        })
        this.is_tj = true
      } else {
        if(this.entity_key == ''){
          this.$Message.warning('关键词不能为空！')
          return
        }
        res = await findEntity({type: 1,keyword: this.entity_key}, (error) => {
          this.$Message.error('请求错误！')
        })
        this.is_tj = false
      }
      if(res.status == 'success') {
        this.search_list = []
        this.loading1 = false
        res.res.map((a) => {
          this.search_list.push({
            description: a.description,
            id: a.id,
            logo_path: a.logo_path,
            round_id: a.round_id,
            short_name: a.short_name,
            type: a.type,
            uid: a.uid,
            a_id: '',
            is_active: false
          })
        })

        this.sel_com.map((a) => {
          let is_active = this.search_list.findIndex((item) => {
            return item.id == a.sub_type_id
          })
          if(is_active > -1){
            this.search_list[is_active].is_active = true
            this.search_list[is_active].a_id = a.a_id
          }
        })
        this.len = res.count
        this.entity_keys = this.entity_key
        this.first_search = false
      } else {
        console.log(res)
      }
    },
    async attentionEntity(arr) {
      // console.log(arr)
      let res = await findEntity({type: 1,ids: arr,keyword: ""}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.attention_com = []
        this.loading2 = false
        this.tag_loading = false
        this.clear_loading = false
        this.group_subscribe.map((b)=>{
          res.res.map((a) => {
            if(a.id == b.sub_type_id){
              this.attention_com.push({
                description: a.description,
                id: a.id,
                logo_path: a.logo_path,
                round_id: a.round_id,
                short_name: a.short_name,
                type: a.type,
                uid: a.uid,
                a_id: b.id
              })
            }
          })
        })
        if(this.all_show){
          this.show_attention_com = this.attention_com
        }else{
          this.show_attention_com = this.attention_com.slice(0, 3)
        }
      } else {
        console.log(res)
      }
    },
    showMore() {
      this.all_show = !this.all_show
      if(this.all_show){
        this.show_attention_com = this.attention_com
      }else{
        this.show_attention_com = this.attention_com.slice(0, 3)
      }
    },
    goEntityDetail(uid) {
      this.$router.push({name: 'OrgDetail', params: {uid: uid}})
    }
  },
  created() {
    // console.log(this.group_subscribe)
    this.searchEntity('create')
    this.attentionEntity(this.sel_com_id)
  },
  watch: {
    sel_com_id(arr) {
      this.attentionEntity(arr)
    },
    tag_loading(val) {
      if(val && !this.all_show) {
        this.show_attention_com = this.attention_com.slice(0, 2)
      }else if(val && this.all_show){
        this.show_attention_com = this.attention_com
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/attention.stylus'
</style>
